import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpWall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowUpWall"><Path d="M4.5 20.5H19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 16.5V4" stroke="currentColor" strokeLinecap="square"/><Path d="M7 8.5L12 3.5L17 8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowUpWall;
